// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function useHttps(url) {
  return (url || '').replace(/^http:\/\//i, 'https://');
}
function useWss(url) {
  return (url || '').replace(/^ws:\/\//i, 'wss://');
}

// 请求接口地址 如果没有配置自动获取当前网址路径
var VUE_APP_API_URL = useHttps(process.env.VUE_APP_BASE_API || "".concat(location.origin));
var VUE_APP_WS_URL = useWss(process.env.VUE_APP_WS_URL || "".concat(location.protocol === 'https:' ? 'wss' : 'ws', "://").concat(location.hostname));
var SettingMer = {
  // 服务器地址
  httpUrl: VUE_APP_API_URL,
  // 接口请求地址
  apiBaseURL: VUE_APP_API_URL + '/api/',
  // socket连接
  wsSocketUrl: VUE_APP_WS_URL
};
export default SettingMer;